import { Directive, ElementRef, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[appanimatecss]',
})
export class AnimateCssDirective {
  constructor(public renderer: Renderer2, public hostElement: ElementRef) {
  }

  ngOnChanges() {
    var dd = '';
  }
  ngAfterViewInit(): void {
    this.renderer.addClass(this.hostElement.nativeElement, 'animate__animated');
    this.renderer.addClass(this.hostElement.nativeElement, 'animate__faster');

  }

  @Input() set appanimatecss(value: string) {
    if (value.toString() == 'false') {
      this.renderer.removeClass(this.hostElement.nativeElement, 'animate__animated');
      return;
    };
    this.renderer.addClass(this.hostElement.nativeElement, 'animate__animated');

    if (value) {
      var classList = value.split(' ');
      classList.map(x => {
        if (x.indexOf('animate__') < 0) {
          x = 'animate__' + x;
        }
        this.renderer.addClass(this.hostElement.nativeElement, x);

      })
    }
    else {
      this.renderer.addClass(this.hostElement.nativeElement, 'animate__fadeInUpSmall');
      this.renderer.addClass(this.hostElement.nativeElement, 'animate__faster');
    }
  }

}
